/**
 * AIT Format - Protocol Buffer definitions and reader/writer for Apps-in-Toss bundle format.
 *
 * @packageDocumentation
 */

// Re-export protobuf types from generated package
export * from "@apps-in-toss/ait-format-proto";

// Constants
export { FORMAT_VERSION, MAGIC, MAGIC_STRING, HEADER_SIZE } from "./constants";

// Errors
export { AITError, AITFormatError, AITVersionError } from "./errors";

// Main entry point
export { AppsInTossBundle } from "./bundle";

// Reader/Writer
export { AITReader, type AITReaderOptions, type AppJson, type AppJsonMetadata } from "./reader";
export { AITWriter, type AITWriterOptions, type MetadataOptions } from "./writer";

// Format detection
export { BundleFormat, Format } from "./format";
